import { render, staticRenderFns } from "./AIDetail.vue?vue&type=template&id=18512d70&scoped=true"
import script from "./AIDetail.vue?vue&type=script&lang=js"
export * from "./AIDetail.vue?vue&type=script&lang=js"
import style0 from "./AIDetail.vue?vue&type=style&index=0&id=18512d70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18512d70",
  null
  
)

export default component.exports